import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// import SendGoodsOrder from '../views/sendGoodsOrder/index.vue'

// import SubscribeInfoAdd from '../views/subscribInfo/add.vue'

import Layout from "../views/layout/index.vue";

import Login from "../views/login/index.vue";

import ChangeForCount from "../views/changeForCount/index.vue";

import industrySelect from "../views/industrySelect/index.vue";
// import industryChat from '../views/industryChat/index.vue';
import industryChat from "../views/industryChat/newIndex.vue";

import mobileChat from "../views/mobileChat/index.vue";

export const constantRoutes = [
  {
    path: "/",
    redirect: "/industryChat",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/changeForCount",
    name: "ChangeForCount",
    component: ChangeForCount,
  },
  {
    path: "/Layout",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/industrySelect",
        name: "industrySelect",
        component: industrySelect,
      },
      {
        path: "/industryChat",
        name: "industryChat",
        component: industryChat,
      },
      {
        path: "/mobileChat",
        name: "mobileChat",
        component: mobileChat,
      },
    ],
  },
  // {
  //   path: '/addSubscribe',
  //   name: 'SubscribeInfoAdd',
  //   component: SubscribeInfoAdd
  // }
];

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});



// WEBPACK FOOTER //
// ./src/router/index.js